<template>
  <div class="howBody flexwrap">
    <div class="howTextContainer" :class="[imageLeft?'containerLeft':'containerRight']">
      <div class="howText" :style="'background-color:'+color2+'22'" :class="[imageLeft?'textLeft':'textRight']">
          <h2 class="howIcon flexwrap centercenter" :style="'background-color:'+color2"> <i class="fas" :class="icon" ></i></h2>
          <h2>{{title}}</h2>
        <div style="align-self: flex-start; grid-column: 1/3" class="flexwrap">
          <slot></slot>
        </div>

      </div>

    </div>
    <div class=" howImage mediumShadow" :style="{ borderColor: color1 }">
      <img :src="image" :alt="title"/>
    </div>
  </div>
  <!--
<div class="blocBody" :class="imageRight?'imageRight':'imageLeft'">





</div>
-->
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "landingPageBloc",
  props: ['title', 'image', 'imageLeft', 'start', 'icon', 'color1', 'color2'],

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>

  .howBody{
    position: relative;
    align-items: center;
  }

  .howTitle{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 1vw;
  }
  .howTitle>*{
    margin-right: 1vw;
  }

  .howIcon{
    height: 3vw;
    width: 3vw;
    border-radius: 4vw;
    color: var(--goalBackgroundColor3);
  }

  .howTextContainer{
    position: absolute;
    color: var(--standardColor);
    background-color: hsl(20, 45%,97%);
    width: 30vw;
    font-size: 0.9em;
    height: fit-content;
    overflow: hidden;
  }
  .howText{
    color: var(--standardColor);
    background-color: var(--goalBackgroundColor3);
    width: 19vw;
    height: fit-content;
    min-height: 14vw;
    display: grid;
    grid-template-columns: 3vw 1fr;
    grid-template-rows: auto 1fr;
    grid-gap: 1vw;
    align-items: center;
  }
  .containerRight{
    right: 50%;
    border-radius: 2vw 0 0 2vw;
  }
  .containerLeft{
    left:50%;
    border-radius: 0 2vw 2vw 0;
  }
  .textRight{
    padding: 1vw 9vw 1vw 1vw;
  }
  .textLeft{
    padding: 1vw 1vw 1vw 10vw;
  }
  .howImage{
    width: 17vw;
    height: 17vw;
    border-radius: 17vw;
    border: 0.5vw solid var(--standardColor);
    z-index: 5;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: var(--standardColor);
    background-position: center center;
    overflow: hidden;
  }
  .howImage > img{
    width: 17vw;
    height: 17vw;
    object-fit: cover;
  }

  @media screen and (max-device-width: 767px) {

    .howBody{
      position: relative;
      align-items: center;
      height: 148vw;
    }

    .howIcon{
      height: 12vw;
      width: 12vw;
      border-radius: 12vw;
    }
    .howTitle{
      margin-bottom: 4vw;
    }
    .howTitle>*{
      margin-right: 4vw;
    }

    .howImage{
      width: 80vw;
      height: 80vw;
      border-radius: 80vw;
      border: 2vw solid var(--standardColor);
      align-self: flex-start;
    }
    .howImage > img{
      width: 80vw;
      height: 80vw;
    }

    .howTextContainer{
      width: 80vw;
      font-size: 0.9em;
      height: 93vw;
    }
    .howText{
      width: 74vw;
      height: 52vw;
      min-height: 62vw;
      display: grid;
      grid-template-columns: 12vw 1fr;
      grid-template-rows: auto 1fr;
      grid-gap: 3vw;
      align-items: center;
      align-self: flex-end;
    }
    .containerRight,.containerLeft{
      bottom: 0;
      left: 2vw;
      right: auto;
      border-radius: 0 0 6vw 6vw;
    }
    .textRight,.textLeft{
      padding: 32vw 3vw 3vw 3vw;
    }
  }
</style>